module.exports = __webpack_public_path__ + "img/bkash.5a0d7295.png";